import React, { useState, useEffect } from "react";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import { Filter, Download, Search, Eye, Package } from "react-feather";
import { Spinner, Badge } from 'react-bootstrap';
import * as XLSX from 'xlsx';
import axios from "axios";
import { baseurl, imageUrl } from "../../Baseurl";
import { Link } from "react-router-dom";
import { FaSearchPlus } from "react-icons/fa";
import SearchListingLink from "./AdminComp/SearchListingLink";

const AllListing = () => {
  const [listings, setListings] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    const fetchListings = async () => {
      try {
        const response = await axios.get(`${baseurl}getAllSellerListings`);
        if (response.data.success) {
          setListings(response.data.data);
          setFilteredData(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching listings:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchListings();
  }, []);

  const handleDownloadExcel = () => {
    const exportData = filteredData.map(({ listing_image, ...item }) => item);
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "All Seller Listings");
    XLSX.writeFile(wb, "all_seller_listings.xlsx");
  };

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredData.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  // Custom Inline Styles for extra polish
  const styles = {
    card: {
      border: "none",
      borderRadius: "12px",
      boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
      overflow: "hidden"
    },
    tableHeader: {
      backgroundColor: "#f8f9fa",
      color: "#495057",
      fontWeight: "600",
      textTransform: "uppercase",
      fontSize: "0.75rem",
      letterSpacing: "0.5px"
    },
    productImg: {
      width: "50px",
      height: "50px",
      borderRadius: "8px",
      objectFit: "cover",
      border: "1px solid #eee"
    },
    searchBar: {
      borderRadius: "20px",
      paddingLeft: "40px",
      backgroundColor: "#f1f3f5",
      border: "none"
    }
  };

  return (
    <div className="App" style={{ display: "flex", backgroundColor: "#f4f7f6", minHeight: "100vh" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "25px", maxWidth: "100%" }}>
        <AdminTopbar />
        
        <div className="container-fluid mt-4">
          <div className="row mb-4 align-items-center">
            <div className="col-md-4">
              <h3 className="fw-bold m-0" style={{ color: "#2d3436" }}>Product Inventory</h3>
              <p className="text-muted small">Manage and monitor all seller listings</p>
            </div>
            
            <div className="col-md-8 d-flex flex-wrap justify-content-md-end gap-2">
              <div className="position-relative" style={{ minWidth: "250px" }}>
                {/* <Search size={16} className="position-absolute" style={{ left: "15px", top: "12px", color: "#adb5bd" }} /> */}
                <input
                  type="text"
                  className="form-control"
                  style={styles.searchBar}
                  placeholder="Search by title..."
                  onChange={(e) => {
                    const keyword = e.target.value.toLowerCase();
                    const filtered = listings.filter((l) => l.title.toLowerCase().includes(keyword));
                    setFilteredData(filtered);
                    setCurrentPage(1);
                  }}
                />
              </div>
              
              <button className="btn btn-outline-primary d-flex align-items-center gap-2" onClick={handleDownloadExcel} style={{ borderRadius: "10px" }}>
                <Download size={16} /> Export
              </button>


              {/* <Link to="/" className="btn btn-outline-primary d-flex align-items-center gap-2" onClick={handleDownloadExcel} style={{ borderRadius: "10px" }}>
                <FaSearchPlus size={16} /> Search By Link
              </Link> */}

              <SearchListingLink />


            </div>
          </div>

          <div className="card" style={styles.card}>
            <div className="card-body p-0">
              {loading ? (
                <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: "300px" }}>
                  <Spinner animation="grow" variant="primary" />
                  <span className="mt-2 text-muted">Loading inventory...</span>
                </div>
              ) : (
                <>
                  <div className="table-responsive">
                    <table className="table table-hover align-middle mb-0">
                      <thead style={styles.tableHeader}>
                        <tr>
                          <th className="ps-4">Product</th>
                          <th>Unique ID</th>
                          <th>Seller</th>
                          <th>Price & Qty</th>
                          <th>Type</th>
                          <th>Delivery</th>
                          <th className="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentRows.length === 0 ? (
                          <tr><td colSpan="7" className="text-center py-5 text-muted">No products found</td></tr>
                        ) : (
                          currentRows.map((row) => (
                            <tr key={row.id}>
                              <td className="ps-4">
                                <div className="d-flex align-items-center">
                                  {row.listing_image ? (
                                    <img src={`${imageUrl}listing/${row.listing_image}`} alt="" style={styles.productImg} />
                                  ) : (
                                    <div style={{...styles.productImg, background: "#eee", display: 'flex', alignItems: 'center', justifyContent: 'center'}}><Package size={20} color="#ccc"/></div>
                                  )}
                                  <div className="ms-3">
                                    <div className="fw-bold text-dark mb-0" style={{ fontSize: "0.9rem" }}>{row.title}</div>
                                    <small className="text-muted">{row.listingstandard || "No Unit"}</small>
                                  </div>
                                </div>
                              </td>
                              <td><code className="text-primary small">{row.qkid}</code></td>
                              <td>
                                <div className="small fw-semibold">{row.business_name}</div>
                                <div className="text-muted" style={{ fontSize: "0.75rem" }}>{row.business_email}</div>
                              </td>
                              <td>
                                <div className="fw-bold">₹{parseFloat(row.price).toLocaleString()}</div>
                                <div>
                                  {row.quantity === null || row.quantity === undefined ? (
                                    <Badge bg="info" pill>Unlimited</Badge>
                                  ) : row.quantity === 0 ? (
                                    <Badge bg="danger" pill>Out of Stock</Badge>
                                  ) : (
                                    <small className="text-muted">Stock: {row.quantity}</small>
                                  )}
                                </div>
                              </td>
                              <td>
                                <Badge bg="light" className="text-dark border">{row.type}</Badge>
                              </td>
                              <td>
                                <small className="text-secondary"><Filter size={12}/> {row.delivery_method}</small>
                              </td>
                              <td className="text-center pe-4">
                                <Link to={`/admin/seller-listing-details/${row.id}`} className="btn btn-sm btn-light shadow-sm border" title="View Details">
                                  <Eye size={16} className="text-primary" />
                                </Link>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Pagination Section */}
                  <div className="d-flex flex-wrap justify-content-between align-items-center p-4 border-top">
                    <div className="d-flex align-items-center gap-2">
                      <span className="small text-muted">Show</span>
                      <select
                        className="form-select form-select-sm"
                        style={{ width: "70px", borderRadius: "8px" }}
                        value={rowsPerPage}
                        onChange={(e) => {
                          setRowsPerPage(parseInt(e.target.value));
                          setCurrentPage(1);
                        }}
                      >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                      </select>
                    </div>

                    <div className="d-flex align-items-center gap-3">
                      <button
                        className="btn btn-sm btn-outline-secondary px-3"
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage(currentPage - 1)}
                        style={{ borderRadius: "8px" }}
                      >
                        Prev
                      </button>
                      <span className="small fw-bold">
                        {currentPage} / {totalPages}
                      </span>
                      <button
                        className="btn btn-sm btn-outline-secondary px-3"
                        disabled={currentPage === totalPages}
                        onClick={() => setCurrentPage(currentPage + 1)}
                        style={{ borderRadius: "8px" }}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllListing;